<template>
  <div class="card" v-if="recapitulatifMontant">
    <header class="header-card">
      <p>
        {{ $t('detailPlanMedia.montant.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantTtc',
          { montant: recapitulatifMontant.montantTtc }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantHt',
          { montant: recapitulatifMontant.montantHt }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantTva',
          { montant: recapitulatifMontant.montantTva }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantFacture',
          { montant: recapitulatifMontant.montantFacture }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantResteAFacturer',
          { montant: recapitulatifMontant.montantResteAFacturer }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantAcompte',
          { montant: recapitulatifMontant.montantAcompte }) }}
        </div>
        <div class="column is-2">
          {{ $t('detailPlanMedia.montant.montantRegle',
          { montant: recapitulatifMontant.montantRegle }) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recapitulatifMontant',
  props: {
    recapitulatifMontant: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>

</style>
